module.exports = __webpack_public_path__ + "img/home.78281f9d.jpg";